import { ReactElement, useEffect } from 'react';
import { Grid } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { useFormikContext } from 'formik';
import { useFilterTable } from 'shell/hooks/use-filter-table';
import { useListener } from 'shell/hooks/use-bus';
import { EventFormPractice } from 'practice/constants/research-state-enum';
import { ResearchMunicipalityForm } from 'civil-status/view-models/research-municipality';
import PmiTextField from 'shell/components/shared/text-field';
import { researchMunicipalityInitialValues } from 'civil-status/pages/research-municipality/municipalityInitializer';

const FormFilter = (): ReactElement => {
  const formContext = useFormikContext<ResearchMunicipalityForm>();

  const filterTable = useFilterTable<ResearchMunicipalityForm>();

  useListener<ResearchMunicipalityForm>(EventFormPractice.UpdateForm, (form) => {
    formContext.setValues({ ...formContext.values, ...form });
  });

  useEffect(() => {
    filterTable.setValues(formContext.values);
  }, [formContext.values]);

  useEffect(() => {
    formContext.setValues(filterTable.values || researchMunicipalityInitialValues);
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="ID Comune"
          aria-label="ID Comune"
          name="id"
          id="id"
          fullWidth
          value={formContext.values?.id || ''}
          onChange={(event) => formContext.setFieldValue('id', event.target.value)}
          inputProps={{
            maxLength: '10',
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Descrizione Comune"
          aria-label="Descrizione Comune"
          name="description"
          id="description"
          fullWidth
          value={formContext.values?.description || ''}
          onChange={(event) => formContext.setFieldValue('description', event.target.value)}
          inputProps={{
            maxLength: '100',
          }}
        />
      </Grid>
      <Grid item xs={12} md={1}>
        <PmiButton variant="contained" color="secondary" fullWidth type="submit">
          Cerca
        </PmiButton>
      </Grid>
    </Grid>
  );
};

FormFilter.displayName = 'Practice Research - Filter Practice - Form Filter component';

export default FormFilter;
